import { useLocationSearch } from '@rocketlane/rocket-router';
import { useEffect, useRef, useState } from 'react';

const getFilterAsString = (search) => {
  const searchParams = new URLSearchParams(search);
  const params = [...searchParams.entries()];

  return JSON.stringify(
    params.filter((param) => param[0] === 'criteria' || param[0] === 'type'),
  );
};

export const useFilterEffect = (onFilterChange: () => void): void => {
  const search = useLocationSearch();
  const [lastProceedFilter, setLastProceedFilter] = useState(
    getFilterAsString(search),
  );
  const callbackRef = useRef(onFilterChange);

  useEffect(() => {
    callbackRef.current = onFilterChange;
  }, [onFilterChange]);

  useEffect(() => {
    const current = getFilterAsString(search);

    if (lastProceedFilter !== current) {
      setLastProceedFilter(current);
      callbackRef.current();
    }
  }, [lastProceedFilter, search]);
};
